// This file is compiled inside Decidim core pack. Code can be added here and will be executed
// as part of that pack

// Load images
require.context("../../images", true)

// Accessibility Scripts
import './accessibility_scripts';

// Header Scripts
import './header_scripts.js'

// Custom initializer
import './custom_external_links_initializer.js'

//Utility functions for general-purpose use across the application.
import './random-utils'



